import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import withConfig from 'util/hoc/with-config';
import ScrollAnimation from 'library/util/scroll';

class HeaderOne extends React.Component {
  handleScroll = () => {
    const scrollTop = window.scrollY;
    const innerHeight = window.innerHeight;
    const scrollTime = Math.abs((scrollTop - innerHeight) / innerHeight) * 500;
    new ScrollAnimation(scrollTop, innerHeight, scrollTime, 'quad.easeInOut');
  }

  render() {
    const {
      configuration
    } = this.props;

    return (
      <Fragment>
        <h1>
          <small>
            { resolve(configuration, 'apps/pathways/configuration/onboarding_steps/experience/header/sub', 'my')}
          </small>
          { resolve(configuration, 'apps/pathways/configuration/onboarding_steps/experience/header/main', 'experience')}
        </h1>
        <p>Employers care about your experience, so we do too! Entering your previous work helps us identify transferable skills to calculate the best career path for you. The more specific you can be, the more personalized your results.</p>

        <div className="pathways-start-header-content">
          <button onClick={this.handleScroll}>Get Started</button>
        </div>
      </Fragment>
    );
  }
}
export default withConfig(HeaderOne);
